export default __webpack_public_path__ + "static/media/file-image.b0c909a0.svg";